import statusEnum from '@/utils/constants/student/appointmentStatusEnum';
import { Colors } from '../../common';

export default {
  methods: {
    getColor: (status) => {
      let color = '';
      switch (status) {
        case statusEnum.completed:
          color = Colors.YELLOW;
          break;
        case statusEnum.confirmed:
          color = Colors.GREEN;
          break;
        case statusEnum.coordinated:
          color = Colors.PINK;
          break;
        case statusEnum.extended:
          color = Colors.CREAM;
          break;
        case statusEnum.cancelled_De:
        case statusEnum.cancelled_Prov:
          color = Colors.BROWN;
          break;
        case statusEnum.denied:
          color = Colors.VIOLET;
          break;
      }
      return color;
    },
  },
};
